
export enum PredefinedAdditionalServiceEnum {
  ExtraService = 0,
  CrossingBoarders = 1,
  OneWayRentalService = 2,
  Drivers = 3,
  Eazyrent = 4,
  RentalDelivery = 5,
  AdditionalDrivers = 6,
  OperationsOutsideWorkingHours = 7
}

export enum AdditionalServiceType {
  Service = 1,
  Charge = 2
}
export enum RentalDeliveryTypeEnum {
  Delivery = 1,
  Receive = 2
}
export enum ModeType {
  Add = 1,
  Edit = 2,
  View = 3
}

export enum PolicyType {
  DepositPolicy = 1,
  CancelationPolicy = 2,
  FuelChargingPolicy = 3,
  ExceededDistancePolicy = 4,
  AgeRestrictionPolicy = 5,
  EarlyReturnPolicy = 6,
  RentalReplacementPolicy = 7,
  RentalContractTerminationPeriodPolicy = 8,
  LateReturnWithNoShowPolicy = 9,
  RentalContractExtensionPolicy = 10,
  UnavailableBookedVehicleHandlingPolicy = 11,
  SecurityDepositPolicy = 12
}

export enum DepositPolicyPaymentTypes {
  PercentageOfTotalCharges = 1,
  FullPaymentIsRequired = 2,
  NoPaymentIsRequired = 3
}

export enum CancelationPolicyChargeTypes {
  FreeCancelation = 1,
  ApplyCancelationCharges = 2
}
export enum FuelChargingPolicyTypes {
  FreeFuel = 1,
  ApplyCharges = 2
}


export enum RentalContractTerminationPeriodTypes {
  ApplyOldRatesCapturedOnPickupOnConsumedRentalPeriod = 1,
  RecalculateRentalChargesBasedOnConsumedPeriodAndNewRate = 2,
  //WaiverRentalCharges = 3,
  LetAgentDecide = 3
}
export enum ExceededDistancePolicyTypes {
  FreeDistance = 1,
  ApplyChargesOnExceededDistance = 2
}
export enum ExtensionRules {
  AllowExtensionBasedOnAvailability = 1,
  ForceExtensionOnSameVehicleEvenIfNot = 2
}
export enum AppliedChargingRateOnExtendedPeriod {
  ApplyOldRatesOnExtendedRentalPeriod = 1,
  RecalculateNewRentalChargesBasedOnNewRentalPeriod = 2,
  LetAgentDecide = 3
}

export enum AgeRestrictionPolicyTypes {
  NoAgeRestrictions = 1,
  ApplyChargesForSpecificAgeRangeAsARiskFactor = 2
}

export enum AppliedChargingRate {
  ApplyOldRatesOnNewRentalPeriod = 1,
  ApplyNewRatesBasedOnNewRentalPeriod = 2,
  LetAgentDecide = 3
}

export enum AppliedRateTypeID {
  ApplyOldRatesOnNewSelectedVehicle = 1,
  ApplyNeWRatesOnNewSelectedVehicle = 2,
  LetAgentDecide = 3
}
export enum SecurityDepositType {
  NoSecurityDepositRequired = 1,
  ApplySecurityDeposit = 2
}
export enum AllowedReplacementTypeID {
  SameClass = 1,
  // OneRankUpperClass = 2,  Audai
  AnyClass = 2
}
export enum AmountPolicyTypes {
  Fixed = 1,
  Percentage = 2
}

export enum WorkflowInstancePossibleActionEnum {
  ReservationCancelConfirmed = 77,
  ReservationUpdateConfirmed = 78,
  ReservationExtendContract = 710
}


export enum VehicleReservationState {
  Intial = 0, /* intial booking*/
  Draft = 1, /*draft booking*/
  Deleted = 2,
  PendingAuthorization = 3,
  Confirmed = 4, /*confirmed booking*/
  Cancelled = 5, /*Cancelled Booking*/
  Pickedup = 6, /*Booking is realized and vehicle is picked up, the contract is now Open*/
  Extended = 7, /*contract is extended when the rental contract rental period is extended by the customer, the contract is now Open-Extended*/
  Returned = 8,
  Overdue = 9, /*Rental car is returned but outstanding payment is not fulfilled.*/
  LegalFollowup = 10,//1.    Rental car is returned with unfulfilled outstanding payment that has been over due for a time period > set related grace period in setting or has been directed to legal by agent
  //2.    Rental car return date is exceeded along with grace period and customer didn’t show up to return vehicle, so agent manually chose to direct it for legal follow-up.
  Closed = 11, /*Rental is returned and all charges are fulfilled */
  Terminated = 12, /*Rental Contract has been terminated for a specific reason */
  Replaced = 13, /*Rental Contract is in pending status due to vehicle replacement which resulted anew rental contract , refer to replace vehicle under a running contract function */
  FinalClose = 14,
  ReportedAsStolen = 15
}

export enum CustomerEligibilityEnum {
  SorryCustomerIsBlacklisted = 1,
  SorryCustomerIsNotEligibleToBookAge = 2,
  SorryCustomerIsNotEligibleToBookExceedingMaxConcurrentRentals = 3,
}

export enum DiscountScopeEnum {
  None = 0,
  RentalPeriod = 1,
  TotalCharges = 2
}
export enum AgencyReturnLocationTypes {
  Branch = 1,
  AffliateAgency = 2,
  LiaisonAgent = 3,
  ParkingZone = 4

}

export enum RentalTypeViewEnum {
  Pickup = 1,
  Return = 2,
}

export enum ChargeSummaryMode {
  Add = 0,
  Modify = 1,
}
